/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import MyEditor from '../MyEditor';
// import BasicDropDownFullLink from '../../../Form/BasicDropDowns/BasicDropDownFullLink';

import imageModifier from '../../../../utils/imageModifier';
import SingleObjUploaderWithSelector from '../../Mam/SingleObjUploaderWithSelector';
import Modal from '../../../Modal/Modal';

// import imageModifier from '../../../../utils/imageModifier';
// import SingleObjUploaderWithSelector from '../../Mam/SingleObjUploaderWithSelector';
// import Modal from '../../../Modal/Modal';

const InstructionsModule = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'InstructionsSimpleUploadLogo',
    logoUrl: '',
    paragraph: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    includeSeparator: false,
    background: 'transparent',
  };

  // const icons = [
  //   'icon-file',
  //   'icon-greenpeace',
  //   'icon-greener-festival',
  //   'icon-sustainable-mat',
  //   'icon-tram',
  //   'icon-bus',
  //   'icon-flora',
  //   'icon-taxi',
  //   'icon-subway',
  //   'icon-bicycle',
  //   'icon-car',
  //   'icon-train',
  //   'icon-boat',
  //   'icon-plane',
  //   'icon-primavera-tree',
  //   'icon-login',
  //   'icon-clock',
  //   'icon-c02',
  //   'icon-staff',
  //   'icon-apple',
  //   'icon-recycle-round',
  //   'icon-recycle-black',
  //   'icon-ride',
  //   'icon-sun',
  //   'icon-cup',
  //   'icon-water',
  //   'icon-package',
  //   'icon-toilets',
  //   'icon-beach',
  //   'icon-cigar',
  //   'icon-ipad',
  // ];

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isColorWhite, setColorWhite] = useState(false);
  const [isSeparatorIn, setSeparatorIn] = useState(false);
  const [isModalOn, setModalState] = useState(false);
  const [imageObj, setimageObj] = useState({});

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);

      if (component) {
        setState(component);
        component.background === 'white' ? setColorWhite(true) : setColorWhite(false);
        component.includeSeparator ? setSeparatorIn(true) : setSeparatorIn(false);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  const setImage = ([obj]) => {
    toggleModal();
    setimageObj(obj);
    const { component } = components[index];

    const comp = {
      ...component,
      logoUrl: obj.url,
    };

    console.log('comp_setObj', comp);

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const inputHandler = (value, name, lang) => {
    const comp = {
      ...state,
      [name]: {
        ...state[name],
        [lang.toLowerCase()]: value,
      },
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const handleInput = (contentHtml, lang) => {
    if (index >= 0) {
      inputHandler(contentHtml, 'paragraph', lang);
    }
  };

  useEffect(() => {
    if (index >= 0 && components.length) {
      const { component } = components[index];
      const borderColor = isColorWhite ? 'white' : 'transparent';

      const comp = {
        ...component,
        includeSeparator: isSeparatorIn,
        background: borderColor,
      };
      console.log('comp', comp);
      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  }, [isColorWhite, isSeparatorIn]);

  // const storeOption = (option) => {
  //   const { component } = components[index];
  //   const comp = {
  //     ...component,
  //     icon: option,
  //   };

  //   setState(comp);

  //   const componentObj = {
  //     id,
  //     component: comp,
  //   };

  //   handlerSetComponents(componentObj, index);
  // };

  return (
    <>
      {languages.map(lang => (
        <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} w-full pl-4 bg-greyFilter rounded-lg`}>
          <div className="w-full bg-greyFilter pl-10 pr-3 rounded-lg">
            <div className="bg-greyFilter pr-2 flex items-center h-15">
              <label className="flex flex-col font-americaMonoRegular text-xs uppercase text-black items-center" htmlFor="backgroundColor">
                Background Color
                <div className="mt-1 pb-0">
                  <label className="switch mb-0 pb-0 h-6">
                    <input checked={isColorWhite} onChange={() => setColorWhite(!isColorWhite)} type="checkbox" />
                    <div className="switch-slider btn-tw switch-round" />
                  </label>
                </div>
              </label>
              <label className=" ml-10 flex flex-col font-americaMonoRegular text-xs uppercase text-black items-center pr-6" htmlFor="borderColor">
                Include Separator
                <div className="mt-1 pb-0">
                  <label className="switch mb-0 pb-0 h-6">
                    <input className="switch" checked={!isSeparatorIn} onChange={() => setSeparatorIn(!isSeparatorIn)} type="checkbox" />
                    <div className="switch-slider btn-yn switch-round" />
                  </label>
                </div>
              </label>
              <div className="pt-1 flex items-center">
                {state && state.hasOwnProperty('logoUrl') && state.logoUrl && (
                <label htmlFor="icon" className="flex items-start justify-end flex-col font-americaMonoRegular text-xs uppercase text-black pl-2 mr-4 mt-2">
                  Icon
                  <div className="flex">
                    <div
                      style={{
                        backgroundImage: `url(${state && state.hasOwnProperty('logoUrl') && state.logoUrl})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        width: '100px',
                        height: '40px',
                      }}
                      className="mr-2 p-1 rounded mt-1"
                    />
                  </div>
                </label>
                )}
                <button className={`font-americaMonoBold text-xs pl-7 py-2 rounded-full uppercase bg-black text-white flex flex-row items-center h-10 w-48 pl-6 ${state && state.hasOwnProperty('logoUrl') && state.logoUrl ? 'mt-6' : 'mt-4'}`} type="button" onClick={() => toggleModal()}>
                  {state && state.hasOwnProperty('logoUrl') && state.logoUrl ? 'Change svg logo' : 'Select svg logo'}
                  {state && state.hasOwnProperty('logoUrl') && state.logoUrl ? <span className="font-icon icon-loading-arrows text-sm pl-2 text-white" /> : <span className="font-icon icon-add-button text-base text-white font-bold pl-2" />}
                </button>
              </div>
              {/* <div className="font-americaMonoRegular text-xs uppercase mt-2 w-full pt-1 flex flex-row items-center" htmlFor="marginTop">
            <PageTypeCheckbox checked={state.marginTop === true} value="checkedA" onClick={handleMarginTop} />
            <span className="font-americaMonoRegular text-xs uppercase text-black" onChange={handleMarginTop} onClick={handleMarginTop}>
              Margin Top
            </span>
          </div> */}
            </div>
            <label className="relative flex flex-col font-americaMonoRegular text-xs  text-black " htmlFor="paragraphText">
              <span className="uppercase">Paragraph</span>
              <div className="text-black font-americaMonoRegular p-2 overflow-auto text-xs leading-normal mt-2 mb-3 bg-white rounded">
                <MyEditor retrieveInput={handleInput} lang={lang} value={state.paragraph[lang.toLowerCase()]} classes="px-8 pb-4" />
              </div>
            </label>
          </div>
        </div>
      ))}
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle zIndex="5" singleUploader>
          <SingleObjUploaderWithSelector selectCallback={setImage} />
        </Modal>
      )}
    </>
  );
};

InstructionsModule.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
};
InstructionsModule.defaultProps = {
  reusableComponent: null,
};

export default InstructionsModule;
